import { faroCoreApiClient } from "@api/faro-core-api-client";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface SetFeatureInBundleProps {
  /** The bundle whose feature list is changed */
  bundleId: FaroCoreApiTypes.AdmBundle["id"];

  /** The feature that is added to or removed from the bundle */
  featureId: FaroCoreApiTypes.AdmFeature["id"];

  /** Whether the feature is added to the bundle or removed from it */
  shouldAdd: boolean;
}

/** Adds a single feature to a bundle or removes it from the bundle, returning the updated bundle */
export function setFeatureInBundle({
  bundleId,
  featureId,
  shouldAdd,
}: SetFeatureInBundleProps): Promise<FaroCoreApiTypes.AdmBundle> {
  return shouldAdd
    ? faroCoreApiClient.admin.addFeatureToBundle({ bundleId, featureId })
    : faroCoreApiClient.admin.removeFeatureFromBundle({ bundleId, featureId });
}
